export default "__VITE_ASSET__uLTT$Kbc__"